import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '~/components/app-shell'
import { ExamsSection } from '~/components/exam-list'
import { ProfileReminder } from '~/components/profile-card'

export const Route = createFileRoute('/_authed/app/')({
  head: () => ({ meta: [{ title: `${m.nav_dashboard()} – ${m.app_name()}` }] }),
  component: DashboardPage,
})

function DashboardPage() {
  const { session } = Route.useRouteContext()
  const active = session.active?.organization

  return (
    <>
      <PageHeader
        title={m.dashboard_title({ name: session.user.name })}
        description={
          active &&
          (active.kind === 'personal'
            ? m.dashboard_working_in_personal()
            : m.dashboard_working_in({ organization: active.name }))
        }
      />
      <ProfileReminder />
      <ExamsSection />
    </>
  )
}
